export default __webpack_public_path__ + "static/media/img13.20be4895.jpg";